<template lang="html">
  <li class="interactive-list-item settings-item">
    <label class="label with-toggle" @touchstart="">
      <span class="span">{{label}}</span>
      <input
        class="switch-dark"
        :type="type"
        v-model="state" />
    </label>
    <p
      v-if="showComment && comment"
      class="comment"
    >
      {{comment}}
    </p>
  </li>
</template>

<script>
export default {

  name: 'Setting',

  props: {
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true,
      validator: function (value) {
        return ['checkbox', 'radio'].indexOf(value) !== -1
      }
    },
    setting: {
      required: true
    },
    showComment: {
      type: Boolean,
      required: false,
      default: true
    },
    comment: {
      type: String,
      required: false,
      default: ""
    },
  },

  data(){
    return{
      state: this.setting,
    }
  },

  watch: {

    // Update item's state if setting gets changed by parent
    setting(newVal){
      this.state = newVal
    },

    // Update parent when setting is changed with this component.
    state(){
      this.$emit('update', this.state)
    }
  }
}
</script>

<style scoped lang="scss">

@import '../style/abstracts/variables.scss';
@import '../style/abstracts/functions.scss';
@import '../style/abstracts/mixins.scss';

.settings-item{

  .label{

    .span{
      margin: 0;
    }
  }
}
.switch-dark{
  margin: 0;
}
.comment{
  position: relative;
  margin-bottom: $medium + rem;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/SettingItem.vue